import React, { useEffect, useState } from "react";
// @ts-ignore
import style from "./UnsupportedBrowserBanner.module.css";
import { detect } from "detect-browser";
import { HiMiniXMark } from "react-icons/hi2";
// @ts-ignore
import { IconWrapper } from "@viuti/recursos";

const browser = detect();

const UnsupportedBrowserBanner = ({ visibility }) => {
  const [isUnsupported, setIsUnsupported] = useState(false);
  const { isVisible, setIsVisible } = visibility;

  useEffect(() => {
    const unsupportedBrowsers = ["ie", "safari"];
    if (browser && unsupportedBrowsers.includes(browser.name)) {
      setIsUnsupported(true);
      setIsVisible(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!isUnsupported) {
    return null;
  }

  return (
    <div className={`${style.banner} ${isVisible ? style.banner_visible : ""}`}>
      <p>
        Parece que estás utilizando un navegador web no compatible. Para
        disfrutar de la mejor experiencia, te recomendamos actualizar a un
        navegador optimizado como Chrome.
      </p>
      <button
        type="button"
        className={style.close__button}
        onClick={() => setIsVisible(false)}
      >
        <IconWrapper icon={HiMiniXMark} size={20} color="#fff" />
      </button>
    </div>
  );
};

export default UnsupportedBrowserBanner;
